export enum DataObjectVersionUrl {
  SOURCES = '/data-object-versions{/id}/sources',
  METADATA_VERSIONS = '/data-object-versions{/id}/metadata-versions',
}
